<template>
  <div class="article_ui">
    <Breadcrumb></Breadcrumb>
    <div class="article_content">
      <div class="title">{{query.title}}</div>
      <p class="title_f">
        <span class="time">{{query.ctime}}</span>
        <!-- <span class="eye"> <i class="iconfont iconliulan"></i>6666</span> -->
        <span class="name">{{query.author}}</span>
      </p>
      <div class="content_box" v-if="type=='file'">
        <iframe :src="src" frameborder="0"></iframe>
      </div>
      <el-image class="img"  v-if="type=='image'" :src="query.url" :alt="query.name" fit="cover"></el-image>
     
      <a v-if="type=='file'||type=='other'" class="download download-btn" :href="query.url" :download="query.name" @click="downLoad">{{query.name}}</a>
      <video v-if="type=='video'" style="width:100%;height:350px" controls="controls">
        <source :src="query.url" type="video/mp4" />
        <source :src="query.url" type="video/ogg" />
        <source :src="query.url" type="video/webm" />
        <object :data="query.url" style="width:100%;height:350px">
          <embed :src="query.url" style="width:100%;height:350px" />
        </object>
      </video>
      <audio v-if="type=='radio'" :src="query.url">
      您的浏览器不支持 audio 标签。
      </audio>
      <div class="down">
        <p>资源文件：
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconword"></use>
          </svg>
          <span class="down_title" :alt="query.title"> {{query.title}}</span>
          <a href="javascript:;" class="down_btn" @click="onlinePreviewone(query)">下载</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadCount } from '@/api/common_api'

import moment from 'dayjs'
import { Breadcrumb } from '@/components'

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      query:this.$route.query,
      src:''
     };
  },
  created() {
    this.type=this.matchType(this.query.title);
    var type=this.type
    if(type=='txt'||type=='excel'||type=='word'||type=='pdf'||type=='ppt'){
      this.type='file'
    }
    let domain = window.location.host;
    // let domain='192.168.1.179:80'
    this.src= 'http://120.27.241.131:8088/?furl='+window.location.protocol+'//' + domain +this.query.url
  },
  computed: {
    
  },
  methods: {
    downLoad(){
        downloadCount({id:this.query.id}).then(function (res) {
          if (res.s == 1) {
          }
        })
      },
      /*
       * @param: fileName - 文件名称
       * @param: 数据返回 1) 无后缀匹配 - false
       * @param: 数据返回 2) 匹配图片 - image
       * @param: 数据返回 3) 匹配 txt - txt
       * @param: 数据返回 4) 匹配 excel - excel
       * @param: 数据返回 5) 匹配 word - word
       * @param: 数据返回 6) 匹配 pdf - pdf
       * @param: 数据返回 7) 匹配 ppt - ppt
       * @param: 数据返回 8) 匹配 视频 - video
       * @param: 数据返回 9) 匹配 音频 - radio
       * @param: 数据返回 10) 其他匹配项 - other
       */
      matchType(fileName) {
        // 后缀获取
        var suffix = '';
        // 获取类型结果
        var result = '';
        try {
          var flieArr = fileName.split('.');
          suffix = flieArr[flieArr.length - 1];
        } catch (err) {
          suffix = '';
        }
        // fileName无后缀返回 false
        if (!suffix) {
          result = false;
          return result;
        }
        // 图片格式
        var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
        // 进行图片匹配
        result = imglist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'image';
          return result;
        };
        // 匹配txt
        var txtlist = ['txt'];
        result = txtlist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'txt';
          return result;
        };
        // 匹配 excel
        var excelist = ['xls', 'xlsx'];
        result = excelist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'excel';
          return result;
        };
        // 匹配 word
        var wordlist = ['doc', 'docx'];
        result = wordlist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'word';
          return result;
        };
        // 匹配 pdf
        var pdflist = ['pdf'];
        result = pdflist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'pdf';
          return result;
        };
        // 匹配 ppt
        var pptlist = ['ppt'];
        result = pptlist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'ppt';
          return result;
        };
        // 匹配 视频
        var videolist = ['mp4', 'm2v', 'mkv'];
        result = videolist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'video';
          return result;
        };
        // 匹配 音频
        var radiolist = ['mp3', 'wav', 'wmv','ogg'];
        result = radiolist.some(function (item) {
          return item == suffix;
        });
        if (result) {
          result = 'radio';
          return result;
        }
        // 其他 文件类型
        result = 'other';
        return result;
      },
   onlinePreviewone(file) {

      downloadCount({id:file.id}).then(function (res) {
        if (res.s == 1) {
            
        }
      })
      var url = file.url
      var link = document.createElement('a');
      link.setAttribute("download", file.title);
      link.href = url;
      link.click();

    },
  }
};
</script>

<style lang="less" scoped>
.article_ui{
  width: 100%;
  height: 1052Px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(235, 235, 235, 0.5);
  padding:0 14Px;
  box-sizing: border-box;
  font-size:14Px;
  .icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.3em;
    fill: currentColor;
    overflow: hidden;
  }
  .el-image{
    width:100%;
  }
  .article_content{
    padding:0 95Px;
    margin-top:24Px;
    .title{
      min-height: 22Px;
      color: rgba(68, 68, 68, 1);
      font-size: 16Px;
      text-align: left;
      font-family: PingFangSC-Medium;
    }
    .title_f{
      margin-top:10Px;
      color:#666666;
      height:20Px;
      line-height:20Px;
      margin-bottom:15Px;
      .eye{
        font-size:12Px;
        position:relative;
        padding-left:25Px;
        margin-left:10Px;
        .iconfont{
          margin-right:5Px;
          font-size:18Px;
          left:0;
          position:absolute;
        }
      }
      .name{
        float:right;
      }
    }
    .content_box{
      margin-top:10Px;
      img{
        width:100%;height:auto;
      }
      iframe{
        width:100%;
        height:450Px;
      }
    }
  }
  .down{
    color:#909399;
    margin-top:22px;
    .down_btn{
      color:#1890FF;
    }
    .down_title{
      width:200px;
      overflow:hidden; 
      text-overflow:ellipsis; 
      white-space:nowrap; 
    }
  }
}
</style>
